import { rem } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
    display: grid;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 0 auto;
    row-gap: ${rem(40)};
    padding: ${rem(96)} 0 ${rem(96)};
    max-width: ${rem(660)};
    width: 100%;
`;

export const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Logo = styled.img`
    max-height: ${rem(48)};
    max-width: ${rem(150)};
`;
